import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledImgAvatar = styled.span`
  background-color: ${props => props.theme.colors.grayLight};
  background-size: cover;
  border-radius: 50%;
  color: ${props => props.theme.colors.light};
  display: block;
  font-size: 0.5rem;
  font-family: ${props => props.theme.fonts.medium};
  height: ${rem('45px')};
  left: 0;
  overflow: hidden;
  // width: ${rem('45px')};
  ${mediaqueries.lessThan('mobile')`
    height: ${rem('33.8px')};
    
  `};
  @supports (clip-path: circle()) or (-webkit-clip-path: circle()) {
    clip-path: circle();
    overflow: initial;
  }
`;

const StyledFirstChar = styled.span`
  align-items: center;
  background-color: inherit;
  color: ${props => props.theme.colors.light};
  display: flex;
  font-size: ${props => (props.full ? '3rem' : '1rem')};
  font-family: inherit;
  height: 100%;
  justify-content: center;
  border-radius: 50%;
  text-transform: uppercase;
`;

const StyledImg = styled.img`
  height: 100%;
  width: ${props => (props.full === true ? '100%' : 'min-content')};
  object-fit: cover;
  ${props =>
    props.directory === true &&
    css`
      width: 100% !important;
      transform: scale(1);
    `}
  border-radius: 25px;
`;

const StyledLink = styled.a`
  cursor: pointer;
  z-index: 1000;
`;

export { StyledImgAvatar, StyledFirstChar, StyledImg, StyledLink };
